module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0025.4294e4a2.jpg";